import { API_CONFIG, PRODUCTION, UAT } from "common/config";
import { COMMON_JS } from "common/scripts";

const local = PRODUCTION === "false" && UAT === "false";
const LOCAL_PORT = "7008";

export const REPORTS_APIs = {
  getAttendanceReport: async (args = {}) => {
    let apiUrl = "/re/v1/GUG971E6XH7BWVO9";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getLeaveReport: async (args = {}) => {
    let apiUrl = "/re/v1/OW73GZWPXT4JDGGK";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getCustomerTypeReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/3H5PUTSBPUFG5EL6";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getCustomerReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/E3Z911JD87IJFWOB";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getAreaSalesReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/FME20ASSCMXPE63J";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getCitySalesReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/EN0VE48EVTCHE4U3";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getRegionSalesReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/VCUUEBNAUXH54M07";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getStateSalesReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/G9YKIX7E1QX4D1WB";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getProductSalesReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/0M0RVCUPN3SU043U";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getSubCategorySalesReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/BGWL9P9KFEZII4D6";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getMainCategorySalesReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/9CCXGMX5PABM4C0L";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getCategorySalesReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/XRT1YYY56XYM3C0L";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getSchemeUtilizationReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/WNT5YDZ9M92LC3LW";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getSchemesReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/5CRQWRUHR56NHXMN";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getTargetsReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/B43OH9XOSFZCT1Z6";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getTotalTargetStatusReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/TKVTYL6P1V7DKV5J";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getProductTargetStatusReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/0QBUQCLX2SR5KT08";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getOrderDetailReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/C29UHVCNX81ZP312";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getBeatOrderReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/0NCPSLXKORUV0BPB";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getTeamReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/IIQTKPZDSXTXG4J7";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getCityList: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/PXK2SBMZH8A1WD8F";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getProductsReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/RAKW5XEL3PRKE8R1";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getAllLogsRegister: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/3ZH3C254DU6EE6LD";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getUserDetailedLog: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/883Y5851A13563IH";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getAreaList: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/XGF94VWQN7J94CNP";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getPriceListReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/FVX7SBHH4KBQATB7";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  // getCrmLeadReport: async (args = {}, accessToken = "") => {
  //   const response = await COMMON_JS.callApi(
  //     "/re/v1/HCJ4PAPSAWA2T6Y0",
  //     API_CONFIG.METHODS.GET,
  //     args
  //   );
  //   return response;
  // },

  getCrmLeadReport: async (args = {}) => {
    let resObj: any = {};
    resObj = {
      status: 200,
      response: {
        rows: [
          {
            id: 20,
            stateName: "Gujarat",
            customers: "125000",
            newLeads: "750",
            unservedLeads: "500",

            underservedLeads: "250",
          },
          {
            id: 20,
            stateName: "Maharashtra",
            customers: "25000",
            newLeads: "100",
            unservedLeads: "90",

            underservedLeads: "10",
          },
        ],
      },
    };
    return resObj;
  },

  getFeedbackReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/63IL9SW3DTYT9JX8";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getInstructionReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/YWS6V5RDJ51O2PRP";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getSurveyReport: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/1HCTO1NUHV5O5Z6Q";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getCustomerList: async (args = {}, accessToken = "") => {
    let apiUrl = "/re/v1/1N93YNBAR5M8QQKJ";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getCustomerOrders: async (args = {}) => {
    let apiUrl = "/re/v1/OWBV161Y2H0A3Q75";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getSalesMonthly: async (args = {}) => {
    let apiUrl = "/re/v1/631I2314N61107YP";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getRouteReport: async (args = {}) => {
    let apiUrl = "/re/v1/XGF94VWQN7J94CNP";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getGeoDrillDownReport: async (args = {}) => {
    let apiUrl = "/re/v1/getgeodilldown";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getAllCustomers: async (args = {}) => {
    let apiUrl = "/re/v1/GQSIRMDAXBXRLT2C";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getLocationUpdate: async (args = {}) => {
    let apiUrl = "/re/v1/9BVLSFZ7J99B4LW1";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  // getCrmLeadReport: async (args = {}) => {
  //   let apiUrl = "/re/v1/HCJ4PAPSAWA2T6Y0";
  //   if (local) {
  //     apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
  //   }
  //   const response = await COMMON_JS.callApi(
  //     apiUrl,
  //     API_CONFIG.METHODS.GET,
  //     args,
  //     false,
  //     local
  //   );
  //   return response;
  // },

  // POS Reports
  getPosRetailSale: async (args = {}) => {
    let apiUrl = "/re/v1/CGZWWGP0OHWB0EHY";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getPosBillItem: async (args = {}) => {
    let apiUrl = "/re/v1/X03D11QWN9QXBNSO";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getPosBillRegister: async (args = {}) => {
    let apiUrl = "/re/v1/0BLYU4FT9UT4IHYK";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getPosDaywiseMonthly: async (args = {}) => {
    let apiUrl = "/re/v1/64ZJYJROD8ESZKZS";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getPosIbtRegister: async (args = {}) => {
    let apiUrl = "/re/v1/V04IRI76D4IHNUI8";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getPosIbtOutwardRegister: async (args = {}) => {
    let apiUrl = "/re/v1/9B5OFYG6K1N9DL4F";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getPosStockReport: async (args = {}) => {
    let apiUrl = "/re/v1/P2M2TFR3J1U3I2JD";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getPosPresentStock: async (args = {}) => {
    let apiUrl = "/re/v1/W2AAVI3U4JIV0BGE";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getPosStockAdjustment: async (args = {}) => {
    let apiUrl = "/re/v1/PJ1HF2KHNCKN7744";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getPosPurchase: async (args = {}) => {
    let apiUrl = "/re/v1/D10KEMHTM36G8LC3";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getPosConsolidatePurchase: async (args = {}) => {
    let apiUrl = "/re/v1/M61IWQ28Q0C6AY1O";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getPosItemsList: async (args = {}) => {
    let apiUrl = "/re/v1/U1NBENYIZZH7KLZ6";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getPosDuplicateBillReport: async (args = {}) => {
    let apiUrl = "/re/v1/CAJX66V3K8NQ9AA7";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  // DMS Report
  getDmsSalesOrder: async (args = {}) => {
    let apiUrl = "/re/v1/C55E0NFM0AZGM4W3";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getDmsDeletedOrder: async (args = {}) => {
    let apiUrl = "/re/v1/GQSIRMDAXBXRLT2C";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getDmsSalesBill: async (args = {}) => {
    let apiUrl = "/re/v1/WJPKYM8NEFH341AY";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getDmsDeletedBill: async (args = {}) => {
    let apiUrl = "/re/v1/Z76NAUMT4AAS345L";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getDmsPartyStatus: async (args = {}) => {
    let apiUrl = "/re/v1/M1GBOSFWQ2XK12ZT";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getDmsSalesBillRegister: async (args = {}) => {
    let apiUrl = "/re/v1/Z1LG4APYOYV41RB4";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getDmsSalesReturn: async (args = {}) => {
    let apiUrl = "/re/v1/9BVLSFZ7J99B4LW1";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getDmsOrderBill: async (args = {}) => {
    let apiUrl = "/re/v1/HFGG6VJ3CR13A0MY";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getDmsBillPayment: async (args = {}) => {
    let apiUrl = "/re/v1/NU9JLVMKVUYKKBK8";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getDmsPurchaseBill: async (args = {}) => {
    let apiUrl = "/re/v1/FLIJRM7U62KACFM3";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getDmsTotalSummary: async (args = {}) => {
    let apiUrl = "/re/v1/O1TJ3YZ556IX8QVI";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getDmsSalesmanSummary: async (args = {}) => {
    let apiUrl = "/re/v1/6FOVHI9TM2DSLTF9";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getDmsCurrentStock: async (args = {}) => {
    let apiUrl = "/re/v1/PU43PDC765H9I3NW";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getGraphData: async (args = {}) => {
    let apiUrl = "/re/v1/karthik";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getChartData: async (args = {}) => {
    // const jsonData = require("components/Karthik/data1.json");
    const jsonData = "";
    let response = {
      status: 200,
      response: jsonData,
    };
    return response;
  },

  getCustomerPieChartData: async (args = {}) => {
    const PiejsonData = require("components/GraphDashboard/view1pie.json");
    let response = {
      status: 200,
      response: PiejsonData,
    };
    return response;
  },

  getCustomerColumnChartData: async (args = {}) => {
    const ColjsonData = require("components/GraphDashboard/view1col.json");
    let response = {
      status: 200,
      response: ColjsonData,
    };
    return response;
  },

  getProductColumnChartData: async (args = {}) => {
    const ColjsonData = require("components/GraphDashboard/view2col.json");
    let response = {
      status: 200,
      response: ColjsonData,
    };
    return response;
  },
  getProductPieChartData: async (args = {}) => {
    const piejsonData = require("components/GraphDashboard/view2pie.json");
    let response = {
      status: 200,
      response: piejsonData,
    };
    return response;
  },
  getRsmPieChartData: async (args = {}) => {
    const piejsonData = require("components/GraphDashboard/view3pie.json");
    let response = {
      status: 200,
      response: piejsonData,
    };
    return response;
  },
  getRsmBarChartData: async (args = {}) => {
    const barjsonData = require("components/GraphDashboard/view3bar.json");
    let response = {
      status: 200,
      response: barjsonData,
    };
    return response;
  },

  getRsmDrilldownChartData: async (args = {}) => {
    const drilljsonData = require("components/GraphDashboard/view3drill.json");
    let response = {
      status: 200,
      response: drilljsonData,
    };
    return response;
  },

  getTask: async (args = {}) => {
    let apiUrl = "/re/v1/getTask";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getOnePager: async (args = {}) => {
    let resObj: any = {};
    resObj = {
      status: 200,
      response: {
        records: [
          {
            id: 1,
            performance: "Primary",
            ftd: "",
            mtd: "",
            mtdTarget: "",
            previousMonth: "",
            ytd: "",
          },
          {
            id: 2,
            performance: "Secondary",
            ftd: "",
            mtd: "",
            mtdTarget: "",
            previousMonth: "",
            ytd: "",
          },
          {
            id: 3,
            performance: "No.of New Outlets",
            ftd: "",
            mtd: "",
            mtdTarget: "",
            previousMonth: "",
            ytd: "",
          },
          {
            id: 4,
            performance: "Revenue per Outlet",
            ftd: "",
            mtd: "",
            mtdTarget: "",
            previousMonth: "",
            ytd: "",
          },
          {
            id: 5,
            performance: " Category Wise Sales",
            ftd: "",
            mtd: "",
            mtdTarget: "",
            previousMonth: "",
            ytd: "",
          },
          {
            id: 5.1,
            performance: " Chips",
            ftd: "5L",
            mtd: "10L",
            mtdTarget: "",
            previousMonth: "",
            ytd: "",
            subData: true,
          },

          {
            id: 5.2,
            performance: " Namkeen",
            ftd: "6L",
            mtd: "8L",
            mtdTarget: "",
            previousMonth: "",
            ytd: "",
            subData: true,
          },
          {
            id: 6,
            performance: "Avg Time at Outlet",
            ftd: "",
            mtd: "",
            mtdTarget: "",
            previousMonth: "",
            ytd: "",
          },
          {
            id: 7,
            performance: "Total Time in Field",
            ftd: "",
            mtd: "",
            mtdTarget: "",
            previousMonth: "",
            ytd: "",
          },
          {
            id: 8,
            performance: "Dealer Margin",
            ftd: "",
            mtd: "",
            mtdTarget: "",
            previousMonth: "",
            ytd: "",
          },
        ],
      },
    };
    return resObj;
  },

  //KPI REPORT

  getKPIOnTimeDelivery: async (args = {}) => {
    let apiUrl = "/re/v1/3VNQW0Q7S9B44M9G";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIPerfectOrderRate: async (args = {}) => {
    let apiUrl = "/re/v1/U73ISOUU0JCZOIDR";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIMissedOutlets: async (args = {}) => {
    let apiUrl = "/re/v1/5HN8RWECUD1TKI1H";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIFallenBelowAverage: async (args = {}) => {
    let apiUrl = "/re/v1/G83ZVF0ZTQUOU7RX";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIOutletCoverage: async (args = {}) => {
    let apiUrl = "/re/v1/RDE5A7IOKADYSYOB";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIEffectivelyCoveredOutlet: async (args = {}) => {
    let apiUrl = "/re/v1/3DDXT08NXMRK4GPG";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIBillCut: async (args = {}) => {
    let apiUrl = "/re/v1/Z1RXQRFP10WD5IWO";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIFreshGoodsSold: async (args = {}) => {
    let apiUrl = "/re/v1/LYA3YFHCHJVIVRTB";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPICashConversionCycle: async (args = {}) => {
    let apiUrl = "/re/v1/L5NO38KSZWW4E8FX";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIOutOfStockRate: async (args = {}) => {
    let apiUrl = "/re/v1/F83T6SFM4D66F32N";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIGeographyPenetration: async (args = {}) => {
    let apiUrl = "/re/v1/PBGYRS1K0L8GBZOF";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIInvTurnoverRatio: async (args = {}) => {
    let apiUrl = "/re/v1/LSEPL5Y8W5BAS2CK";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPISalesGrowthRate: async (args = {}) => {
    let apiUrl = "/re/v1/YIGGNSD5X4MBUIB0";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIGrossMargin: async (args = {}) => {
    let apiUrl = "/re/v1/9U3ENWSFWOIXX6MB";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIForecastAccuracy: async (args = {}) => {
    let apiUrl = "/re/v1/3TXW2YT6YN3Q0MKF";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIRangeSelling: async (args = {}) => {
    let resObj: any = {};
    resObj = {
      status: 200,
      response: {
        columns: [
          {
            key: "id",
            name: "Id",
            width: "20%",
            type: "number",
            searchable: true,
            sortable: true,
          },
          {
            key: "dealerName",
            name: "Dealer Name",
            width: "30%",
            type: "text",
            searchable: true,
            sortable: true,
          },
          {
            key: "city",
            name: "City",
            width: "25%",
            type: "text",
            searchable: true,
            sortable: true,
          },
          {
            key: "state",
            name: "State",
            width: "25%",
            type: "text",
            searchable: true,
            sortable: true,
          },
        ],
        rows: [
          {
            id: " 123456",
            dealerName: "test1",
            city: "Manglore",
            state: "Karnataka",
          },
          {
            id: " 123458",
            dealerName: "test2",
            city: "Banglore",
            state: "Karnataka",
          },
        ],
      },
    };
    return resObj;

    let apiUrl = "/re/v1/DO6Z84KHQC7Z9RJQ";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getKPIMustSellProduct: async (args = {}) => {
    let resObj: any = {};
    resObj = {
      status: 200,
      response: {
        columns: [
          {
            key: "id",
            name: "Id",
            width: "20%",
            type: "number",
            searchable: true,
            sortable: true,
          },
          {
            key: "dealerName",
            name: "Dealer Name",
            width: "30%",
            type: "text",
            searchable: true,
            sortable: true,
          },
          {
            key: "city",
            name: "City",
            width: "25%",
            type: "text",
            searchable: true,
            sortable: true,
          },
          {
            key: "state",
            name: "State",
            width: "25%",
            type: "text",
            searchable: true,
            sortable: true,
          },
        ],
        rows: [
          {
            id: " 123456",
            dealerName: "test1",
            city: "Manglore",
            state: "Karnataka",
          },
          {
            id: " 123458",
            dealerName: "test2",
            city: "Banglore",
            state: "Karnataka",
          },
        ],
      },
    };
    return resObj;

    let apiUrl = "/re/v1/SMMX48F00GQDUNVV";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  getKPINewOldCustRevenue: async (args = {}) => {
    let apiUrl = "/re/v1/MRZOX9N1I5FNA4I1";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPILTVCustomer: async (args = {}) => {
    let apiUrl = "/re/v1/AS2CEW12JRTCIBW8";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIWeeklySales: async (args = {}) => {
    let apiUrl = "/re/v1/XFG03JL9Y3LWPMG9";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIMonthlySales: async (args = {}) => {
    let apiUrl = "/re/v1/VIHSQYQMGWLP1G22";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIYearlySales: async (args = {}) => {
    let apiUrl = "/re/v1/1VMM12QINSES3XTD";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPISecondaryTarget: async (args = {}) => {
    let apiUrl = "/re/v1/R84QTP2AVPF6MJ3V";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPISecondaryWeekly: async (args = {}) => {
    let resObj: any = {};
    resObj = {
      status: 200,
      response: {
        columns: [
          {
            key: "slNo",
            name: "slNo",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "id",
            name: "id",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "dealerName",
            name: "dealerName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "city",
            name: "city",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "state",
            name: "state",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "srName",
            name: "srName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "soName",
            name: "soName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "asmName",
            name: "asmName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "rsmName",
            name: "rsmName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "date",
            name: "date",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "routeName",
            name: "routeName",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "totalBeats",
            name: "totalBeats",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "hitTotal",
            name: "hitTotal",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "missTotal",
            name: "missTotal",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "successPercent",
            name: "successPercent",
            width: "10%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
        ],
        rows: [
          {
            id: "1",
            dealerName: "Shetty",
            city: "Udupi",
            state: "Karnataka",
            srName: "Karthik",
            soName: "Abhishek",
            asmName: "Eshaan",
            rsmName: "Jnanesh",
            date: "12-10-2023",
            routeName: "Karnataka",
            totalBeats: "20",
            hitTotal: "100",
            missTotal: "100",
            successPercent: "90%",
          },
        ],
      },
    };

    return resObj;

    // let apiUrl = "/re/v1/YQCDPPL4L16EN7UZ";
    // if (local) {
    //   apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    // }
    // const response = await COMMON_JS.callApi(
    //   apiUrl,
    //   API_CONFIG.METHODS.GET,
    //   args,
    //   false,
    //   local
    // );
    // return response;
  },
  getKPIRangeSellingPerCall: async (args = {}) => {
    let resObj: any = {};
    resObj = {
      status: 200,
      response: {
        columns: [
          {
            key: "slNo",
            name: "slNo",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "id",
            name: "id",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "dealerName",
            name: "dealerName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "city",
            name: "city",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "state",
            name: "state",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "srName",
            name: "srName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "soName",
            name: "soName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "asmName",
            name: "asmName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "rsmName",
            name: "rsmName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "date",
            name: "date",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "routeName",
            name: "routeName",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "totalBeats",
            name: "totalBeats",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "hitTotal",
            name: "hitTotal",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "missTotal",
            name: "missTotal",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "successPercent",
            name: "successPercent",
            width: "10%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
        ],
        rows: [
          {
            id: "1",
            dealerName: "Shetty",
            city: "Udupi",
            state: "Karnataka",
            srName: "Karthik",
            soName: "Abhishek",
            asmName: "Eshaan",
            rsmName: "Jnanesh",
            date: "12-10-2023",
            routeName: "Karnataka",
            totalBeats: "20",
            hitTotal: "100",
            missTotal: "100",
            successPercent: "90%",
          },
        ],
      },
    };

    return resObj;

    // let apiUrl = "/re/v1/4W66P1LGFPRZSBZ0";
    // if (local) {
    //   apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    // }
    // const response = await COMMON_JS.callApi(
    //   apiUrl,
    //   API_CONFIG.METHODS.GET,
    //   args,
    //   false,
    //   local
    // );
    // return response;
  },

  getKPIRunRate: async (args = {}) => {
    let resObj: any = {};
    resObj = {
      status: 200,
      response: {
        columns: [
          {
            key: "slNo",
            name: "slNo",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "id",
            name: "id",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "dealerName",
            name: "dealerName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "city",
            name: "city",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "state",
            name: "state",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "srName",
            name: "srName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "soName",
            name: "soName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "asmName",
            name: "asmName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "rsmName",
            name: "rsmName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "date",
            name: "date",
            width: "8%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "routeName",
            name: "routeName",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "totalBeats",
            name: "totalBeats",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "hitTotal",
            name: "hitTotal",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "missTotal",
            name: "missTotal",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "successPercent",
            name: "successPercent",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
        ],
        rows: [
          {
            id: "1",
            dealerName: "Shetty",
            city: "Udupi",
            state: "Karnataka",
            srName: "Karthik",
            soName: "Abhishek",
            asmName: "Eshaan",
            rsmName: "Jnanesh",
            date: "12-10-2023",
            routeName: "Karnataka",
            totalBeats: "20",
            hitTotal: "100",
            missTotal: "100",
            successPercent: "90%",
          },
        ],
      },
    };

    return resObj;

    // let apiUrl = "/re/v1/98BXY9O1UWR8QSYG";
    // if (local) {
    //   apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    // }
    // const response = await COMMON_JS.callApi(
    //   apiUrl,
    //   API_CONFIG.METHODS.GET,
    //   args,
    //   false,
    //   local
    // );
    // return response;
  },

  getKPIRouteHitMiss: async (args = {}) => {
    let resObj: any = {};
    resObj = {
      status: 200,
      response: {
        columns: [
          {
            key: "slNo",
            name: "slNo",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "id",
            name: "id",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "dealerName",
            name: "dealerName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "city",
            name: "city",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "state",
            name: "state",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "srName",
            name: "srName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "soName",
            name: "soName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "asmName",
            name: "asmName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "rsmName",
            name: "rsmName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "date",
            name: "date",
            width: "8%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "routeName",
            name: "routeName",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "totalBeats",
            name: "totalBeats",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "hitTotal",
            name: "hitTotal",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "missTotal",
            name: "missTotal",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "successPercent",
            name: "successPercent",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
        ],
        rows: [
          {
            id: "1",
            dealerName: "Shetty",
            city: "Udupi",
            state: "Karnataka",
            srName: "Karthik",
            soName: "Abhishek",
            asmName: "Eshaan",
            rsmName: "Jnanesh",
            date: "12-10-2023",
            routeName: "Karnataka",
            totalBeats: "20",
            hitTotal: "100",
            missTotal: "100",
            successPercent: "90%",
          },
        ],
      },
    };

    return resObj;

    // let apiUrl = "/re/v1/P9EPMLNFEM36TOZI";
    // if (local) {
    //   apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    // }
    // const response = await COMMON_JS.callApi(
    //   apiUrl,
    //   API_CONFIG.METHODS.GET,
    //   args,
    //   false,
    //   local
    // );
    // return response;
  },

  getKPIWeeklyReport: async (args = {}) => {
    let resObj: any = {};
    resObj = {
      status: 200,
      response: {
        columns: [
          {
            key: "slNo",
            name: "slNo",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "id",
            name: "id",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "dealerName",
            name: "dealerName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "city",
            name: "city",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "state",
            name: "state",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "srName",
            name: "srName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "soName",
            name: "soName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "asmName",
            name: "asmName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "rsmName",
            name: "rsmName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "date",
            name: "date",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "routeName",
            name: "routeName",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "totalBeats",
            name: "totalBeats",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "hitTotal",
            name: "hitTotal",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "missTotal",
            name: "missTotal",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "successPercent",
            name: "successPercent",
            width: "10%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
        ],
        rows: [
          {
            id: "1",
            dealerName: "Shetty",
            city: "Udupi",
            state: "Karnataka",
            srName: "Karthik",
            soName: "Abhishek",
            asmName: "Eshaan",
            rsmName: "Jnanesh",
            date: "12-10-2023",
            routeName: "Karnataka",
            totalBeats: "20",
            hitTotal: "100",
            missTotal: "100",
            successPercent: "90%",
          },
        ],
      },
    };

    return resObj;

    let apiUrl = "/re/v1/8W65OPGWXMFHPQSB";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIWeeklySKU: async (args = {}) => {
    let resObj: any = {};
    resObj = {
      status: 200,
      response: {
        columns: [
          {
            key: "slNo",
            name: "slNo",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "id",
            name: "id",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "dealerName",
            name: "dealerName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "city",
            name: "city",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "state",
            name: "state",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "srName",
            name: "srName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "soName",
            name: "soName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "asmName",
            name: "asmName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "rsmName",
            name: "rsmName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "date",
            name: "date",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "routeName",
            name: "routeName",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "totalBeats",
            name: "totalBeats",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "hitTotal",
            name: "hitTotal",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "missTotal",
            name: "missTotal",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "successPercent",
            name: "successPercent",
            width: "10%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
        ],
        rows: [
          {
            id: "1",
            dealerName: "Shetty",
            city: "Udupi",
            state: "Karnataka",
            srName: "Karthik",
            soName: "Abhishek",
            asmName: "Eshaan",
            rsmName: "Jnanesh",
            date: "12-10-2023",
            routeName: "Karnataka",
            totalBeats: "20",
            hitTotal: "100",
            missTotal: "100",
            successPercent: "90%",
          },
        ],
      },
    };

    return resObj;

    let apiUrl = "/re/v1/PG23IX5S3DLEWMN9";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIDealerVisitReport: async (args = {}) => {
    let resObj: any = {};
    resObj = {
      status: 200,
      response: {
        columns: [
          {
            key: "slNo",
            name: "slNo",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "id",
            name: "id",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "dealerName",
            name: "dealerName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "city",
            name: "city",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "state",
            name: "state",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "srName",
            name: "srName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "soName",
            name: "soName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "asmName",
            name: "asmName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "rsmName",
            name: "rsmName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "date",
            name: "date",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "routeName",
            name: "routeName",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "totalBeats",
            name: "totalBeats",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "hitTotal",
            name: "hitTotal",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "missTotal",
            name: "missTotal",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "successPercent",
            name: "successPercent",
            width: "10%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
        ],
        rows: [
          {
            id: "1",
            dealerName: "Shetty",
            city: "Udupi",
            state: "Karnataka",
            srName: "Karthik",
            soName: "Abhishek",
            asmName: "Eshaan",
            rsmName: "Jnanesh",
            date: "12-10-2023",
            routeName: "Karnataka",
            totalBeats: "20",
            hitTotal: "100",
            missTotal: "100",
            successPercent: "90%",
          },
        ],
      },
    };

    return resObj;

    let apiUrl = "/re/v1/PIJG3D957ZVPFSW7";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getKPIPrimarySales: async (args = {}) => {
    let resObj: any = {};
    resObj = {
      status: 200,
      response: {
        columns: [
          {
            key: "slNo",
            name: "slNo",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "id",
            name: "id",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "dealerName",
            name: "dealerName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "city",
            name: "city",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "state",
            name: "state",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "srName",
            name: "srName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "soName",
            name: "soName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "asmName",
            name: "asmName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "rsmName",
            name: "rsmName",
            width: "10%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "date",
            name: "date",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "routeName",
            name: "routeName",
            width: "5%",
            type: "text",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "totalBeats",
            name: "totalBeats",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "hitTotal",
            name: "hitTotal",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "missTotal",
            name: "missTotal",
            width: "5%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
          {
            key: "successPercent",
            name: "successPercent",
            width: "10%",
            type: "number",
            editable: false,
            sortable: true,
            searchable: true,
            align: "center",
            headerAlign: "center",
          },
        ],
        rows: [
          {
            id: "1",
            dealerName: "Shetty",
            city: "Udupi",
            state: "Karnataka",
            srName: "Karthik",
            soName: "Abhishek",
            asmName: "Eshaan",
            rsmName: "Jnanesh",
            date: "12-10-2023",
            routeName: "Karnataka",
            totalBeats: "20",
            hitTotal: "100",
            missTotal: "100",
            successPercent: "90%",
          },
        ],
      },
    };

    return resObj;

    let apiUrl = "/re/v1/HDQUHVT4RB87EDUU";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
};
